__turbopack_context__.v({
  "bottomBar": "Footer-module__q7ZRWa__bottomBar",
  "brandColumn": "Footer-module__q7ZRWa__brandColumn",
  "column": "Footer-module__q7ZRWa__column",
  "container": "Footer-module__q7ZRWa__container",
  "footer": "Footer-module__q7ZRWa__footer",
  "legalLinks": "Footer-module__q7ZRWa__legalLinks",
  "linkList": "Footer-module__q7ZRWa__linkList",
  "logo": "Footer-module__q7ZRWa__logo",
  "seoText": "Footer-module__q7ZRWa__seoText",
  "socialIcon": "Footer-module__q7ZRWa__socialIcon",
  "socialRow": "Footer-module__q7ZRWa__socialRow",
  "whatsappFloat": "Footer-module__q7ZRWa__whatsappFloat",
});
